import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import uuid from 'uuid/v4';
import Modal from '../common/Modal/Modal';

import { REPORT_TYPES, REPORT_TYPES_MAPPED } from '../../util/QuickReportsUtils';
import {
  QUICK_REPORT_STUDY_TYPES_DEMOGRAPHICS_NOT_ALLOWED,
  QUICK_REPORT_STUDY_TYPES_SEGMENTATION_NOT_ALLOWED,
  QUICK_REPORT_STUDY_TYPES_MAP_NOT_ALLOWED,
  QR_SMA_DISABLED_STUDIES,
  QR_TS_DISABLED_STUDIES,
  MRI_CONNECY_STUDY_STI,
} from '../../actions/urlTypes';
import {
  SIMMONS_CONNECT_STUDY_STI,
  SIMMONS_CONNECT_PLUS_STUDY_STI,
} from '../../constants';

import * as quickReportsActions from '../../actions/quickReportsActions';

const quickReportWarningModalStyle = {
  maxWidth: '50%',
  height: 'auto',
  left: '30%',
  top: '20%',
};

class QuickReportsSelector extends Component {
  constructor(props) {
    super(props);
    this.state = { selectedReport: props.selectedReport };
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.props.selectedReport !== nextProps.selectedReport) {
      this.setState({ selectedReport: nextProps.selectedReport });
    }
  }

  selectReport = report => this.props.quickReportsActions.selectReport(report);

  renderReportItems = () =>
    REPORT_TYPES.map(report => {
      let isSelectable;
       
      if (report.key === 'DEMOPROFILE'
        && this.props.quickReportsStudy
        && this.props.quickReportsStudy.sti
        && QUICK_REPORT_STUDY_TYPES_DEMOGRAPHICS_NOT_ALLOWED
        .indexOf(this.props.quickReportsStudy.sti) !== -1) {
        isSelectable = false;
      } else if (report.key === 'SEGMENTATION'
        && this.props.quickReportsStudy
        && this.props.quickReportsStudy.sti
        && QUICK_REPORT_STUDY_TYPES_SEGMENTATION_NOT_ALLOWED
        .indexOf(this.props.quickReportsStudy.sti) !== -1) {
        isSelectable = false;
      } else if (report.key === 'MAP'
        && ((this.props.quickReportsStudy
        && this.props.quickReportsStudy.sti
        && QUICK_REPORT_STUDY_TYPES_MAP_NOT_ALLOWED
        .indexOf(this.props.quickReportsStudy.sti) !== -1) 
        || (this.props.quickReportsStudy &&
          /local/gi.test( this.props.quickReportsStudy.sd)))) {
        isSelectable = false;
      } else if (report.key === REPORT_TYPES_MAPPED.SMAP) {
        isSelectable = (this.props.quickReportsStudy &&
          /connect/gi.test(this.props.quickReportsStudy.sd) &&
          (this.props.quickReportsStudy.sti === SIMMONS_CONNECT_STUDY_STI ||
            this.props.quickReportsStudy.sti ===
              SIMMONS_CONNECT_PLUS_STUDY_STI)) || (this.props.quickReportsStudy &&
                /connect/gi.test(this.props.quickReportsStudy.sd) &&
                 MRI_CONNECY_STUDY_STI.indexOf(this.props.quickReportsStudy.sti) !== -1) &&
                !(QR_SMA_DISABLED_STUDIES.indexOf(this.props.quickReportsStudy.st) !== -1);
      } else if (report.key === REPORT_TYPES_MAPPED.TIMESPENT) {
        isSelectable = (this.props.quickReportsStudy &&
          /connect/gi.test(this.props.quickReportsStudy.sd) &&
          (this.props.quickReportsStudy.sti === SIMMONS_CONNECT_STUDY_STI ||
            this.props.quickReportsStudy.sti ===
              SIMMONS_CONNECT_PLUS_STUDY_STI)) || (this.props.quickReportsStudy &&
                /connect/gi.test(this.props.quickReportsStudy.sd) &&
                 MRI_CONNECY_STUDY_STI.indexOf(this.props.quickReportsStudy.sti) !== -1) &&
                !(QR_TS_DISABLED_STUDIES.indexOf(this.props.quickReportsStudy.st) !== -1);
      } else {
        isSelectable =
          (this.props.quickReportsStudy &&
            /connect/gi.test(this.props.quickReportsStudy.sd) &&
            (this.props.quickReportsStudy.sti === SIMMONS_CONNECT_STUDY_STI ||
              this.props.quickReportsStudy.sti ===
                SIMMONS_CONNECT_PLUS_STUDY_STI)) ||
          (this.props.quickReportsStudy &&
            /connect/gi.test(this.props.quickReportsStudy.sd) &&
             MRI_CONNECY_STUDY_STI.indexOf(this.props.quickReportsStudy.sti) !== -1 &&
            report.key !== REPORT_TYPES_MAPPED.DIGITALACTIVITY &&
            report.key !== REPORT_TYPES_MAPPED.SIM) ||
          report.isForAllStudy;
      }
      return (
        <div key={uuid()} className="quick-report-card" title={report.name}>
          <div
            key={report.key}
            onClick={() =>
              isSelectable
                ? this.selectReport(report)
                : this.quickReportWarningModal.show()
            }
            className={`card ${
              this.state.selectedReport &&
              this.state.selectedReport.key === report.key &&
              isSelectable
                ? 'selected'
                : ''
            } ${isSelectable ? '' : 'disabled'}`}
          >
            <h5 className="report-title">{report.name}</h5>
            <div className={`report-body ${report.style}`} />
          </div>
        </div>
      );
    });

  checkAccess = () => {
    let isSelectable = true;
    const _quickReportsstudy = this.props.quickReportsStudy;
    REPORT_TYPES.forEach(report => {
      if (report.key === 'DEMOPROFILE'
      && _quickReportsstudy
      && _quickReportsstudy.sti
      && QUICK_REPORT_STUDY_TYPES_DEMOGRAPHICS_NOT_ALLOWED
      .indexOf(_quickReportsstudy.sti) !== -1) {
        isSelectable = false;
      } else if (report.key === 'SEGMENTATION'
        && _quickReportsstudy
        && _quickReportsstudy.sti
        && QUICK_REPORT_STUDY_TYPES_SEGMENTATION_NOT_ALLOWED
        .indexOf(_quickReportsstudy.sti) !== -1) {
          isSelectable = false;
      } else if (report.key === 'MAP'
        && ((_quickReportsstudy
        && _quickReportsstudy.sti
        && QUICK_REPORT_STUDY_TYPES_MAP_NOT_ALLOWED
        .indexOf(_quickReportsstudy.sti) !== -1) 
        || (_quickReportsstudy &&
          /local/gi.test( _quickReportsstudy.sd)))) {
          isSelectable = false;
      } else {
        isSelectable =
          (_quickReportsstudy &&
            /connect/gi.test(_quickReportsstudy.sd) &&
            (_quickReportsstudy.sti === SIMMONS_CONNECT_STUDY_STI ||
              _quickReportsstudy === SIMMONS_CONNECT_PLUS_STUDY_STI)) ||
          (_quickReportsstudy &&
            /connect/gi.test(_quickReportsstudy.sd) &&
             MRI_CONNECY_STUDY_STI.indexOf(_quickReportsstudy.sti) !== -1 &&
            report.key !== REPORT_TYPES_MAPPED.DIGITALACTIVITY &&
            report.key !== REPORT_TYPES_MAPPED.SIM) ||
          report.isForAllStudy;
      }
    });
    return isSelectable;
  }

  render() {
    const checkAccessFlag = this.checkAccess();
    let message = 'Please select a Simmons Connect study to run this Quick Report.';

    if (!checkAccessFlag) {
      message = 'The study you have selected is not compatible with this Quick Report. Please select a different study.';
    }
    return (
      <div className="expanded report-selection-container large-12">
        {this.renderReportItems()}
        <Modal
          title=""
          ref={node => (this.quickReportWarningModal = node)}
          dialogStyles={quickReportWarningModalStyle}
        >
          {this.props.isConnectStudySubscribed
            ? message
            : 'You do not have a Simmons Connect subscription, please contact your Simmons representative.'}
        </Modal>
      </div>
    );
  }
}

QuickReportsSelector.propTypes = {
  quickReportsStudy: PropTypes.shape({
    sti: PropTypes.number,
    sd: PropTypes.string,
    st: PropTypes.string,
  }),
  selectedReport: PropTypes.shape({}),
  isConnectStudySubscribed: PropTypes.bool,
  quickReportsActions: PropTypes.shape({
    selectReport: PropTypes.func,
  }),
};

function mapStateToProps(state) {
  return {
    selectedReport: state.quickReports.selectedReport,
    isConnectStudySubscribed: state.study.isConnectStudySubscribed,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    quickReportsActions: bindActionCreators(quickReportsActions, dispatch),
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(QuickReportsSelector);
